





































































































































import { Component, Prop } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import { BusEvent } from '@/models/bus';

import Module from '@/api/module';
import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import ListLesson from '@/components/listView/ListLesson.vue';
import EditSubmodule from '@/editComponents/EditSubmodule.vue';
import EditLesson from '@/editComponents/EditLesson.vue';
import MassImport from '@/components/MassImport.vue';
import ContentCheck from '@/components/ContentCheck.vue';

@Component({
  components: {
    'list-lesson': ListLesson,
    'edit-submodule': EditSubmodule,
    'edit-lesson': EditLesson,
    'arrow-icon': ArrowIcon,
    'mass-import': MassImport,
    'content-check': ContentCheck
  }
})
export default class LessonView extends CommonVue {
  @Prop({ type: String }) public entity!: string;
  @Prop({ type: Number }) public moduleId!: number;
  @Prop() public id?: number;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public module: Module = null;
  public showImport: boolean = false;
  public contentCheck: boolean = false;
  public file: File | null = null;

  public async beforeMount() {
    this.loadModule();
  }

  public async loadModule(): Promise<void> {
    this.busy = true;
    try {
      this.module = await Module.get(this.moduleId);
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not get module information', e);
    } finally {
      this.busy = false;
    }
  }

  public async downloadModule() {
    const data = await this.module.download();
    const blob = new Blob([data], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `module-${this.moduleId}.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  public async openFileDialog() {
    const link = document.getElementById('file-input');
    link.click();
  }
}
